import Component from '@glimmer/component';

export default class StatusBadgeComponent extends Component {
  get responseCodeType() {
    const responseCode = this.args.responseCode || '0';
    return `site-audit-status-badge--${responseCode.toString().substr(0, 1)}xx`;
  }
}
